import React from "react";
import { Link } from "react-router-dom";
import useLogout from "../../../features/auth/logout/useLogout";
import LogoutConfirmationModal from "../../../features/layout/LogoutConfirmationModal";

const AdminNavigation = ({ currentPath }) => {
  const {
    logoutUserFn,
    showLogoutConfirmation,
    hideLogoutConfirmation,
    showLogoutModal,
    isLoggingOut,
  } = useLogout();

  const navigationItems = [
    {
      path: "/admin/dashboard",
      label: "Dashboard",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
      ),
    },
    {
      path: "/admin/categories",
      label: "Categories",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 4h6v6h-6zM4 14h6v6H4zm10 3a3 3 0 1 0 6 0a3 3 0 1 0-6 0M4 7a3 3 0 1 0 6 0a3 3 0 1 0-6 0"></path>
        </svg>
      ),
    },
    {
      path: "/admin/products",
      label: "Products",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 7h-3V6a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v1H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"></path>
        </svg>
      ),
    },
    {
      path: "/admin/offers",
      label: "Offers",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
        </svg>
      ),
    },
    {
      path: "/admin/orders",
      label: "Orders",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 16 16"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4 2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h.11a1 1 0 0 1 .97.757l.25 1A1 1 0 0 1 12.36 7H12v.5h.5a1 1 0 0 1 1 1V9a1 1 0 0 1-1 1H12v2a1 1 0 0 1-1 1H8.707l-.296.296l-.826 1.651a1 1 0 0 1-.894.553h-3.04a1 1 0 0 1-.554-.168l-1.152-.768a1 1 0 0 1-.445-.832v-3.696a1 1 0 0 1 .01-.142l.934-6.535a1 1 0 0 1 .99-.859H4zm0 1.5h-.566L2.5 10.036v3.696l1.151.768H4.5v-1.333a1 1 0 0 1 .2-.6l2.64-3.52l-.84-.84l-2.146 2.147l-.708-.708L4 9.293zm1 4.793l.793-.793a1 1 0 0 1 1.414 0l.84.84a1 1 0 0 1 .093 1.307L6.375 12H11V2H5zM12 6h.36l-.25-1H12zm0 2.5V9h.5v-.5zM5.625 13l-.125.167V14.5h1.191l.75-1.5zM7.5 3.5V3h1v.5zm.5 0A1.5 1.5 0 0 0 6.5 5H6v1h4V5h-.5A1.5 1.5 0 0 0 8 3.5m0 1a.5.5 0 0 0-.5.5h1a.5.5 0 0 0-.5-.5M6.146 9.854l-.5-.5l.708-.708l.5.5z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      path: "/admin/users",
      label: "User Mgmt",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="m22 21-2-2"></path>
          <path d="M16 16h6"></path>
        </svg>
      ),
    },
    {
      path: "/admin/abandoned-wishlist",
      label: "Abandoned Wishlist",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="m22 21-2-2"></path>
          <path d="M16 16h6"></path>
        </svg>
      ),
    },
    {
      path: "/admin/bundle",
      label: "Bundle Mgmt",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 36 36"
        >
          <path
            fill="currentColor"
            d="m32.43 8.35l-13-6.21a1 1 0 0 0-.87 0l-15 7.24a1 1 0 0 0-.57.9v16.55a1 1 0 0 0 .6.92l13 6.19a1 1 0 0 0 .87 0l15-7.24a1 1 0 0 0 .57-.9V9.25a1 1 0 0 0-.6-.9M19 4.15l10.93 5.22l-5.05 2.44l-10.67-5.35Zm-2 11.49L6 10.41l5.9-2.85l10.7 5.35Zm1 15.8V17.36l13-6.29v14.1Z"
            className="clr-i-solid clr-i-solid-path-1"
            strokeWidth={1}
            stroke="currentColor"
          ></path>
          <path fill="none" d="M0 0h36v36H0z"></path>
        </svg>
      ),
    },
    {
      path: "/admin/announcements",
      label: "Announcements",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 14 14"
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.75.759a.75.75 0 0 0-1.5 0V2.05a.75.75 0 1 0 1.5 0zm-.205 2.84a.625.625 0 0 0-1.113.566L.217 10.813a.625.625 0 0 0-.085.74l.597 1.033a.625.625 0 0 0 .683.296l1.575-.366l.28.487l.002.003a2.017 2.017 0 0 0 3.719-1.419l3.289-.763a.625.625 0 0 0 1.046-.682l-.183-.316l-.032-.055l-3.348-5.8l-.032-.055zM3.127 11.2l.056-.013L9.62 9.693L7.083 5.299l-5.637 6.03l.134.23zm1.222 1.176l-.09-.156l1.51-.35a.767.767 0 0 1-1.42.506M11.2 7a.75.75 0 0 1 .75-.75h1.293a.75.75 0 0 1 0 1.5H11.95A.75.75 0 0 1 11.2 7M.76 6.25a.75.75 0 1 0 0 1.5h1.29a.75.75 0 0 0 0-1.5zm1.296-4.194a.75.75 0 0 1 1.06 0l.914.914a.75.75 0 0 1-1.06 1.06l-.914-.913a.75.75 0 0 1 0-1.06m9.889 1.061a.75.75 0 0 0-1.06-1.06l-.914.913a.75.75 0 1 0 1.06 1.06z"
            clipRule="evenodd"
            strokeWidth={0.5}
            stroke="currentColor"
          ></path>
        </svg>
      ),
    },
    {
      path: "/admin/coupons",
      label: "Coupons",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
        >
          <g fill="none" fillRule="evenodd" clipRule="evenodd">
            <path
              fill="currentColor"
              d="M16.196 5.334c-1.05-.31-2.17-.64-3.299-.94c-3.658-.999-7.356-1.749-8.366-1.998c-.29-.03-.13-.2-1.67 2.578a10 10 0 0 0-.519 1q-.25.53-.43 1.09c-.29.86-.49 1.729-.7 2.598a.37.37 0 0 0 .368.48a.35.35 0 0 0 .312-.24c.39-.79.82-1.54 1.22-2.329c.17-.34.32-.67.48-1s.29-.679.42-.999c.3-.75.59-1.49.899-2.229c1.43.45 4.498 1.48 7.617 2.41c1.119.329 2.249.639 3.298.919c2.369.63 4.338 1.09 4.998 1.28l2.179.679q-.22.234-.4.5q-.075.15-.13.31a1.6 1.6 0 0 0-.08.33c-.16 1.159 0 1.269.2 1.339s.35.22 1-.91q.1-.145.16-.31t.08-.34c.07-.7-.14-.31.14-1a.4.4 0 0 0-.23-.519l-2.63-1.06c-.62-.24-2.548-.909-4.917-1.639"
              strokeWidth={0.5}
              stroke="currentColor"
            ></path>
            <path
              fill="currentColor"
              d="M1.822 5.094c.19-.56.33-1.12.47-1.709c.19-.83.35-1.66.56-2.479h.05l11.225 2.07c1.31.21 2.639.41 3.938.66c.77.149 1.53.329 2.279.529a3 3 0 0 0-.2.34q-.045.135-.06.28q-.023.15 0 .3c.08 1.079.27 1.149.47 1.179s.39 0 .8-1a1.4 1.4 0 0 0 .07-.29q.022-.15 0-.3a3.7 3.7 0 0 0-.19-.7a.4.4 0 0 0-.1-.269a.4.4 0 0 0-.24-.21c-.85-.31-1.72-.57-2.6-.81c-1.289-.36-2.608-.65-3.917-1c-1.51-.299-2.999-.609-4.528-.829c-7.467-1.06-7.677-.5-7.737-.34c-.37.8-.73 1.6-1 2.43c-.17.35-.29.709-.39 1.029q-.165.557-.27 1.13C.274 5.973.184 6.813.014 7.682a.36.36 0 0 0 .24.44a.36.36 0 0 0 .46-.24c.39-.91.8-1.829 1.11-2.789"
              strokeWidth={0.5}
              stroke="currentColor"
            ></path>
            <path
              fill="currentColor"
              d="M12.128 13.2a1.88 1.88 0 0 0 .81-1.479a1.46 1.46 0 0 0-.29-.89a2 2 0 0 0-3.29.32a1.71 1.71 0 0 0 1.06 2.42a1.94 1.94 0 0 0 1.71-.37m-1.64-1.818a.87.87 0 0 1 1.3-.1a.52.52 0 0 1 .07.39c0 .21-.25.35-.46.47a.68.68 0 0 1-.55.13a.56.56 0 0 1-.36-.89m1.13 5.017a1.71 1.71 0 0 0 1.05 2.418a2 2 0 0 0 1.719-.37a1.9 1.9 0 0 0 .81-1.479a1.54 1.54 0 0 0-.29-.88a2 2 0 0 0-3.29.31m1.999.999a.7.7 0 0 1-.56.13a.56.56 0 0 1-.35-.89a.858.858 0 0 1 1.3-.09a.48.48 0 0 1 .07.38c.01.2-.21.34-.42.46zM8.54 15.97a.35.35 0 0 0 .459.2c1-.29 2-.54 2.999-.91c.64-.25 1.25-.58 1.869-.86c.44-.23.86-.48 1.31-.7a8 8 0 0 1 .859-.4a.401.401 0 1 0-.23-.769l-2.419.72c-.64.25-1.3.47-1.92.77c-.939.45-1.798.999-2.718 1.489a.35.35 0 0 0-.21.46"
              strokeWidth={0.5}
              stroke="currentColor"
            ></path>
            <path
              fill="currentColor"
              d="M23.812 12.97c-1.939-1.069-3.878-2.138-5.857-3.118c-.86-.42-1.72-.82-2.599-1.2a43 43 0 0 0-2.649-1.059c-1.739-.63-6.997-2.289-7.236-1.999c-.68 1.1-1.35 2.13-1.93 3.209c-.25.47-.49.95-.7 1.43c-.21.479-.42.999-.599 1.468c-.44 1.15-.8 2.32-1.19 3.509a.404.404 0 1 0 .75.3c.53-1.12 1.09-2.21 1.61-3.299c.23-.47.46-.94.68-1.42l.629-1.429c.42-1 .82-2.059 1.26-3.098a.5.5 0 0 0 .13.11c1.788.61 3.528 1.32 5.257 1.999l1.93.84l2.898 1.239q3.464 1.5 6.897 2.999c-.4 1-.88 1.929-1.33 2.888c-.31.68-.61 1.36-.89 2.05c-.46 1.159-.859 2.338-1.289 3.528a.41.41 0 0 0 .661.45a.4.4 0 0 0 .089-.13c.53-1 1.09-2 1.6-2.999q.514-1.01.919-2.069c.03.02 1.41-3.978.96-4.198m-5.868 9.995c-1.999-.86-3.998-1.829-5.997-2.758c-1.34-.62-2.669-1.25-3.998-1.83c-2.27-1-4.568-1.819-6.897-2.648a.35.35 0 0 0-.47.2a.36.36 0 0 0 .19.46c1.999.929 3.998 1.948 5.997 2.898c1.33.64 2.669 1.25 3.998 1.83c2.27.999 4.578 1.808 6.917 2.608a.408.408 0 0 0 .576-.215a.408.408 0 0 0-.286-.545z"
              strokeWidth={0.5}
              stroke="currentColor"
            ></path>
          </g>
        </svg>
      ),
    },
    {
      path: "/admin/contact",
      label: "contact Mgmt",
      path: "/admin/shipping",
      label: "Shipping",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M22 3H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H2V5h20zm-3-1l2-2l-1.5-2h-1.65c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.65L21 8l-2-2c-1.3 1-2.27 2.38-2.72 4c-.18.64-.28 1.31-.28 2s.1 1.36.28 2c.45 1.61 1.42 3 2.72 4M9 12a3 3 0 0 0 3-3a3 3 0 0 0-3-3a3 3 0 0 0-3 3a3 3 0 0 0 3 3m0-4a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1m6 8.59c0-2.5-3.97-3.59-6-3.59s-6 1.09-6 3.59V18h12zM5.5 16c.72-.5 2.2-1 3.5-1s2.77.5 3.5 1z"
            viewBox="0 0 32 32"
          ></path>
          <path
            fill="currentColor"
            d="M0 6v2h19v15h-6.156c-.446-1.719-1.992-3-3.844-3s-3.398 1.281-3.844 3H4v-5H2v7h3.156c.446 1.719 1.992 3 3.844 3s3.398-1.281 3.844-3h8.312c.446 1.719 1.992 3 3.844 3s3.398-1.281 3.844-3H32v-8.156l-.063-.157l-2-6L29.72 10H21V6zm1 4v2h9v-2zm20 2h7.281L30 17.125V23h-1.156c-.446-1.719-1.992-3-3.844-3s-3.398 1.281-3.844 3H21zM2 14v2h6v-2zm7 8c1.117 0 2 .883 2 2s-.883 2-2 2s-2-.883-2-2s.883-2 2-2m16 0c1.117 0 2 .883 2 2s-.883 2-2 2s-2-.883-2-2s.883-2 2-2"
            strokeWidth={1}
            stroke="currentColor"
          ></path>
        </svg>
      ),
    },
    {
      path: "/admin/support-tickets",
      label: "Support Tickets",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 20 20"
        >
          <path
            fill="currentColor"
            d="M3.5 4A1.5 1.5 0 0 0 2 5.5v9A1.5 1.5 0 0 0 3.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 16.5 4zm3 6a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-1.551.75H8.05a.95.95 0 0 1 .949.949c0 .847-.577 1.585-1.399 1.791l-.059.015c-.684.17-1.4.17-2.084 0l-.06-.015A1.846 1.846 0 0 1 4 11.699a.95.95 0 0 1 .949-.949M11 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
            strokeWidth={0.5}
            stroke="currentColor"
          ></path>
        </svg>
      ),
    },
    {
      path: "/admin/contacts",
      label: "Contacts",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 20 20"
        >
          <path
            fill="currentColor"
            d="M3.5 4A1.5 1.5 0 0 0 2 5.5v9A1.5 1.5 0 0 0 3.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 16.5 4zm3 6a1.5 1.5 0 1 1 0-3a1.5 1.5 0 0 1 0 3m-1.551.75H8.05a.95.95 0 0 1 .949.949c0 .847-.577 1.585-1.399 1.791l-.059.015c-.684.17-1.4.17-2.084 0l-.06-.015A1.846 1.846 0 0 1 4 11.699a.95.95 0 0 1 .949-.949M11 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1"
            strokeWidth={0.5}
            stroke="currentColor"
          ></path>
        </svg>
      ),
    },
    {
      path: "/user/dashboard/profile",
      label: "Update Profile",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={20}
          height={20}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      ),
    },
  ];

  const isActive = (path) => {
    if (path === "/admin/dashboard") {
      return currentPath === path;
    }
    return currentPath.startsWith(path);
  };

  return (
    <nav className="p-4">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Admin Panel
        </h3>
        <div className="w-12 h-1 bg-gradient-to-r from-red-500 to-orange-500 rounded"></div>
      </div>

      <ul className="space-y-2">
        {navigationItems.map((item) => {
          const active = isActive(item.path);
          return (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 group ${
                  active
                    ? "bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-lg"
                    : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                }`}
              >
                <span
                  className={`transition-colors duration-200 ${
                    active
                      ? "text-white"
                      : "text-gray-500 group-hover:text-gray-700"
                  }`}
                >
                  {item.icon}
                </span>
                <span className="font-medium">{item.label}</span>
                {active && (
                  <div className="ml-auto w-2 h-2 bg-white rounded-full"></div>
                )}
              </Link>
            </li>
          );
        })}

        {/* Logout Button */}
        <li className="pt-4 border-t border-gray-200">
          <button
            onClick={showLogoutConfirmation}
            className="flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 w-full text-left text-red-600 hover:bg-red-50 hover:text-red-700 group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={20}
              height={20}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-red-500 group-hover:text-red-600"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16,17 21,12 16,7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span className="font-medium">Logout</span>
          </button>
        </li>
      </ul>

      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal
        open={showLogoutModal}
        onClose={hideLogoutConfirmation}
        onConfirm={logoutUserFn}
        loading={isLoggingOut}
        error={null}
      />
    </nav>
  );
};

export default AdminNavigation;
